export const ConcernDescriptions = [
  { id: "texture", key: "texture", text: "Txt799" },
  { id: "skin_dullness", key: "skin_dullness", text: "Txt789" },
  { id: "face_wrinkles", key: "face_wrinkles", text: "Txt774" },
  { id: "crows_feet", key: "crows_feet", text: "Txt794" },
  { id: "hydration", key: "hydration", text: "Txt759" },
  { id: "shine", key: "shine", text: "Txt965" },
  { id: "firmness", key: "firmness", text: "Txt764" },
  { id: "smoothness", key: "smoothness", text: "Txt964"},
  { id: "eye_wrinkles", key: "eye_wrinkles", text: "Txt784" },
];
